export const pipeSingleValue = (value) => (...fns) => fns.reduce((out, fn) => fn(out), value);
